<template>
	<el-tooltip class="page-up" placement="top" content="回到顶部">
		<back-to-top
			class="icon-top"
			:custom-style="backToTopStyle"
			:visibility-height="300"
			:back-position="0"
			transition-name="fade"
		/>
	</el-tooltip>
</template>

<script>
import { Backtop as BackToTop } from 'element-ui'

export default {
	name: 'ScrollTop',
	components: { BackToTop },
	data() {
		return {
			backToTopStyle: {
				right: '50px',
				bottom: '50px',
				width: '40px',
				height: '40px',
				borderRadius: '4px',
				lineHeight: '45px', // 请保持与高度一致以垂直居中
				background: '#5b4b43', // 按钮的背景颜色
			},
		}
	},
	methods: {},
}
</script>
<style lang="scss" scoped>
.page-up {
	background-color: #409eff;
	position: fixed;
	right: 50px;
	bottom: 30px;
	width: 40px;
	height: 40px;
	border-radius: 20px;
	cursor: pointer;
	transition: 0.3s;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);
	opacity: 0.5;
	z-index: 100;
}
.icon-top {
	color: #fff;
}

.icon-top:hover {
	color: #409eff;
}
</style>
